import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarSubgrupo from '../../components/modal/ModalCadastrarSubgrupo';
import ModalEditarSubgrupo from '../../components/modal/ModalEditarSubgrupo';
import ModalExcluirSubgrupo from '../../components/modal/ModalExcluirSubgrupo';
import { ServicoContext } from '../../context/ServicoContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Subgrupo() {
    const { Success, Error, openModal, setOpenModal, SubgruposConsulta, ListaSubgrupoConsulta, Loading, modalEditarSubgrupo, setModalEditarSubgrupo, setEdicaoSubgrupo, setSubgrupoAtualKey, modalExcluirSubgrupo, setModalExcluirSubgrupo, InativarSubgrupo, ListaFiltroSubgrupo, totalRegistrosSubgrupo, filtroSubgrupo, totalRegistrosFiltroSubgrupo } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditSubgrupo = (props) => {
        setModalEditarSubgrupo(true)
        setSubgrupoAtualKey(props.key)
        setEdicaoSubgrupo(props)
    }

    const DeletarSubgrupo = (props) => {
        setSubgrupoAtualKey(props.key)
        setModalExcluirSubgrupo(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroSubgrupo(searchTerm, currentPage, pageSize);
        } else {
            ListaSubgrupoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroSubgrupo : totalRegistrosSubgrupo;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar subgrupos'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarSubgrupo &&
                <ModalEditarSubgrupo currentPage={currentPage} />
            }
            {modalExcluirSubgrupo &&
                <ModalExcluirSubgrupo currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarSubgrupo closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar subgrupo</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Subgrupos cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroSubgrupo : SubgruposConsulta}
                        columns={[
                            { label: "Nome", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            { label: "Grupo", field: "grupo", width: "40%", render: (x) => x?.grupo?.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarSubgrupo(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditSubgrupo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarSubgrupo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroSubgrupo(term, 1, 10);
                            } else {
                                ListaSubgrupoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Subgrupo;